module.exports = "/packs/images/navigation/social-rectangle-91e391de4c21067665ee6c20332507b5.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/navigation/social-rectangle.png
// module id = 1817
// module chunks = 0